<!-- Promo Card -->
<div *ngIf="cardType === 'promo'" class="mega-card promo">
  <div class="image-container">
    <img [src]="imageUrl" alt="{{ title }}" class="card-image" />
    <div class="gradient-overlay"></div>
    <div class="badge">{{ badgeText }}</div>
    <div class="content">
      <h2 class="overlay-title">{{ title }}</h2>
      <p class="card-description">{{ description }}</p>
      <button class="cta-button right" (click)="onCtaClick()">{{ ctaText }}</button>
    </div>
  </div>
</div>

<!-- Free Card -->
<div *ngIf="cardType === 'free'" class="mega-card free">
  <div class="content">
    <h3 class="card-title">{{ title }}</h3>
    <p class="card-description">{{ description }}</p>
    <button class="cta-button" (click)="onCtaClick()">{{ ctaText }}</button>
  </div>
</div>

<!-- Premium Card -->
<div *ngIf="cardType === 'premium'" class="mega-card premium">
  <div class="header">
    <h3 class="card-title">{{ title }}</h3>
    <span class="status" [ngClass]="status">{{ status | uppercase }}</span>
  </div>
  <p class="card-description">{{ description }}</p>
  <button class="cta-button" (click)="onCtaClick()" [disabled]="status === 'paid'">{{ ctaText }}</button>
</div>

<!-- Locked Content -->
<div *ngIf="cardType === 'locked'" class="mega-card locked">
  <div class="lock-overlay">
    <span class="lock-icon">🔒</span>
    <p class="card-description">{{ description }}</p>
    <button class="cta-button" (click)="onCtaClick()">{{ ctaText }}</button>
  </div>
</div>

<!-- Promo Banner -->
<div class="promo-banner rounded" *ngIf="cardType === 'promo-banner'">
  <div class="promo-content">
    <i class="fas fa-plane-departure promo-icon"></i>
    <div class="promo-text">
      <h2>¿Listo para viajar a Europa?</h2>
      <p class="promo-description">Te ayudamos a empezar tu nueva aventura.</p>
    </div>
    <a (click)="onCtaClick()" class="promo-button">Reservar videollamada</a>
  </div>
</div>

<!-- Promo Banner -->  
<div class="coming-soon-card card" *ngIf="cardType === 'coming-soon'">
  <h2 card="webapp-title-secondary">🚧 En construcción</h2>
  <p>Estamos trabajando en esta sección para que pronto esté disponible para vos. ¡Espérala pronto!</p>
</div>